import { render, staticRenderFns } from "./issue-counts.vue?vue&type=template&id=0d5fad80"
import script from "./issue-counts.vue?vue&type=script&lang=js"
export * from "./issue-counts.vue?vue&type=script&lang=js"
import style0 from "./issue-counts.vue?vue&type=style&index=0&id=0d5fad80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports